import * as Yup from 'yup';
import { t } from 'src/lib/language';
import { idFieldRequired, moneyField } from 'src/lib/ValidatorHelper';
/* eslint-disable import/no-extraneous-dependencies */

const InvoiceOrderValidator = (orders: any, lang:string) => {
  const orderValidator = {};

  orders.forEach((order: any, index: number) => {
    orderValidator[`deductible_${index}`] = Yup.number()
      .min(0)
      .max(100)
      .nullable();
    orderValidator[`discount_${index}`] = moneyField()
      .nullable();
    orderValidator[`note_${index}`] = Yup.string()
      .max(500)
      .nullable();
    orderValidator[`paid_${index}`] = moneyField();
    orderValidator[`product_id_${index}`] = idFieldRequired()
      .required(t(lang, 'validations.invoice.field_required'));
    orderValidator[`quantity_${index}`] = Yup.number()
      .integer(t(lang, 'validations.invoice.field_required'))
      .required();
  });

  return Yup.object().shape(orderValidator);
};

export default InvoiceOrderValidator;
